import { apiClient } from "./apiClient";

export const TRANG_THAI_THI_SINH_API_END_POINT = "trang-thai-thi-sinh";

export const trangThaiThiSinhApi = {

    selectAll: () => apiClient.get(`${TRANG_THAI_THI_SINH_API_END_POINT}`),

};